import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const ItemAnalysisContext = createContext();

const ItemAnalysisProvider = ({ children }) => {
  const [activeStep, setActiveStep] = useState(1);
  const [classes, setClasses] = useState(null);
  const [assignments, setAssignments] = useState(null);
  const [masteryScore, setMasteryScore] = useState(65);
  const [includeRemoved, setIncludeRemoved] = useState(false);
  const [primaryAssignmentName, setPrimaryAssignmentName] = useState('Select an Assignment...');
  const [primaryAssignmentId, setPrimaryAssignmentId] = useState(0);

  const [compare1Name, setCompare1Name] = useState('Select an Assignment...');
  const [compare1Id, setCompare1Id] = useState(0);

  const [compare2Name, setCompare2Name] = useState('Select an Assignment...');
  const [compare2Id, setCompare2Id] = useState(0);

  const [compare3Name, setCompare3Name] = useState('Select an Assignment...');
  const [compare3Id, setCompare3Id] = useState(0);

  const [compare4Name, setCompare4Name] = useState('Select an Assignment...');
  const [compare4Id, setCompare4Id] = useState(0);

  const [compare5Name, setCompare5Name] = useState('Select an Assignment...');
  const [compare5Id, setCompare5Id] = useState(0);

  return (
    <ItemAnalysisContext.Provider value={{
      activeStep, setActiveStep, classes, setClasses, assignments, setAssignments, masteryScore, setMasteryScore, includeRemoved, setIncludeRemoved
      , primaryAssignmentName, setPrimaryAssignmentName, primaryAssignmentId, setPrimaryAssignmentId, compare1Name, setCompare1Name, compare1Id, setCompare1Id
      , compare2Name, setCompare2Name, compare2Id, setCompare2Id, compare3Name, setCompare3Name, compare3Id, setCompare3Id, compare4Name, setCompare4Name
      , compare4Id, setCompare4Id, compare5Name, setCompare5Name, compare5Id, setCompare5Id
    }}>
      {children}
    </ItemAnalysisContext.Provider>
  );
};

ItemAnalysisProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useItemAnalysisContext = () => useContext(ItemAnalysisContext);
export { ItemAnalysisProvider };
